import React from 'react';
import { CardCVCElement, CardExpiryElement, CardNumberElement, injectStripe } from 'react-stripe-elements';
import Grid from '@material-ui/core/Grid/Grid';
import Typography from '@material-ui/core/Typography/Typography';
import debounce from 'lodash/debounce'
import { withStyles } from "@material-ui/core";

const styles = {
  container: {
    '&& label': {
      display: 'block',
      padding: '12px 15px',
      border: '1px solid rgba(178,178,178,0.5)',
      borderRadius: 3,
    },
    '&& label > input': {
      color: '#212322',
      fontFamily: 'Roboto',
      fontSize: 14,
      border: 'none',
      width: '100%'
    }
  }
};

class Form extends React.Component {
  state = {
    fields: {
      cardNumber: {
        error: true
      },
      cardExpiry: {
        error: true
      },
      cardCvc: {
        error: true
      },
      cardOwner: {
        error: true
      }
    }
  };

  handleSubmit = () => {
    if (this.props.stripe) {
      this.props.stripe.createPaymentMethod('card').then((result) => {
        if (result.error) return;
        this.props.onChange(result.paymentMethod.id, this.props.stripe);
      }).catch(e => console.error(e));
    }
  };

  handleChange = event => {
    this.setState(({fields}) => ({fields: {...fields, [event.elementType]: event}}), () => this.onChange());
  };

  handleNameChange = event => {
    const target = event.target;
    this.setState(({fields}) => ({
      fields: {
        ...fields,
        [target.name]: {error: !target.value}
      }
    }), () => this.onChange());
  };


  onChange = debounce(() => {
    if (this.isInvalid()) {
      this.props.onChange(null);
    }
    this.handleSubmit();
  }, 1000);


  isInvalid = () => {
    const {fields} = this.state;
    return Object.entries(fields).reduce((prev, [key, {error}]) => {
      return prev || !!error;
    }, false)
  };

  render() {
    const {classes} = this.props;
    return <form className={classes.container}>
      <Grid container spacing={3}>
        <Grid item xs={10}>
          <label>
            <Typography>
              Name on a card
            </Typography>
            <input type="text" name="cardOwner" data-testid="card-owner" onChange={event => this.handleNameChange(event)}/>
          </label>
        </Grid>
        <Grid item xs={10}>
          <label>
            <Typography>
              Card number
            </Typography>
            <CardNumberElement data-testid="card-number" onChange={this.handleChange}/>
          </label>
        </Grid>
        <Grid item xs={5}>
          <label>
            <Typography>
              Card expiration date
            </Typography>
            <CardExpiryElement data-testid="card-expiration-date" onChange={this.handleChange}/>
          </label>
        </Grid>
        <Grid item xs={5}>
          <label>
            <Typography>
              Card CVC number
            </Typography>
            <CardCVCElement data-testid="card-cvc-number" onChange={this.handleChange}/>
          </label>
        </Grid>
      </Grid>
    </form>
  }
}

export default withStyles(styles)(injectStripe(Form));
